import graphql from "babel-plugin-relay/macro";
import { useFragment } from "react-relay";

import { useIsUserSignedIn_session$key } from "./__generated__/useIsUserSignedIn_session.graphql";

export const useIsUserSignedIn = (
  sessionRef?: useIsUserSignedIn_session$key | null
) => {
  const session = useFragment(useIsUserSignedInFragmentString, sessionRef);
  return !!session?.user?.id;
};

const useIsUserSignedInFragmentString = graphql`
  fragment useIsUserSignedIn_session on Session {
    user {
      id
    }
  }
`;
